import React from 'react';
import LegacyHeadline, { HeadlineProps } from './Headline.legacy';
import AlphaHeadline from './Headline.alpha';

const Component = process.env.IS_LEGACY ? LegacyHeadline : AlphaHeadline;
export default Component as React.FC<HeadlineProps>;
export type { HeadlineProps };
